// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-title[data-v-21b6e47e] {\n  font-size: 1.875rem;\n  color: #003545;\n}\n.target-item-list[data-v-21b6e47e] {\n  max-height: 360px;\n  overflow-y: auto;\n}\n.v-btn.v-btn--depressed[data-v-21b6e47e] {\n  min-width: 17% !important;\n}\n.v-text-field[data-v-21b6e47e] {\n  width: 400px;\n}", ""]);
// Exports
module.exports = exports;
